import {string, email} from '../../../helpers/validations';

export const validationMap = {
    name: string,
}
